import { inject, Injectable } from '@angular/core';
import { LogLevelEnum } from '../../enums/log-level/log-level.enum';
import { LogTypeEnum } from '../../enums/log-type/log-type.enum';
import { LOG_LEVEL } from '../../providers/log-level/log-level.token';

@Injectable({
    providedIn: 'root',
})
export class LogService {
    logLevel = inject(LOG_LEVEL, { optional: true }) ?? LogLevelEnum.ALL;

    log = this.#buildMethod(LogLevelEnum.ALL, LogTypeEnum.LOG);
    debug = this.#buildMethod(LogLevelEnum.DEBUG, LogTypeEnum.DEBUG);
    info = this.#buildMethod(LogLevelEnum.INFO, LogTypeEnum.INFO);
    warn = this.#buildMethod(LogLevelEnum.WARN, LogTypeEnum.WARN);
    error = this.#buildMethod(LogLevelEnum.ERROR, LogTypeEnum.ERROR);

    #buildMethod(level: LogLevelEnum, method: LogTypeEnum) {
        return (...params: unknown[]) => {
            if (level >= this.logLevel) {
                console[method](...params);
            }
        };
    }
}
